import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpSubnavigationComponent from './adpSubnavigation.component';

let adpSubnavigationModule = angular.module('adpSubnavigation', [
  uiRouter
])

.component('adpSubnavigation', adpSubnavigationComponent)

.name;

export default adpSubnavigationModule;



// WEBPACK FOOTER //
// ./src/app/components/adpSubnavigation/adpSubnavigation.js